import React from "react";
import { Link } from "react-router-dom";
import { accountLinks, accountData } from "../Components/accountData";
const Dashboard = (props) => {
  return (
    <div className="dashboard">
      <div className="account-info">
        {props.user.length > 1 ? (
          <h2>Welcome {props.user.toUpperCase()}</h2>
        ) : (
          ""
        )}
        <h1>Your Account: </h1>
        <div className="info-links">
          {accountData.map((card, index) => {
            return (
              <Link to={`${card.link}`} className="link-card" key={index}>
                <div>
                  <img src={card.img} alt="" />
                </div>
                <div className="link-card-text">
                  <h4>{card.title}</h4>
                  <p>{card.desc}</p>
                </div>
              </Link>
            );
          })}
        </div>
        <div className="dashboard-cards">
          <div className="dashboard-link-cards">
            <h3>Ordering and shopping preferences</h3>
            {accountLinks.ordering.map((card, index) => {
              return (
                <div key={index} className="dashboard-card">
                  <Link to="/" className="card-link">
                    {card}
                  </Link>
                </div>
              );
            })}
          </div>
          <div className="dashboard-link-cards">
            <h3>Digital content and devices</h3>
            {accountLinks.digitalContent.map((card, index) => {
              return (
                <div key={index} className="dashboard-card">
                  <Link to="/" className="card-link">
                    {card}
                  </Link>
                </div>
              );
            })}
          </div>
          <div className="dashboard-link-cards">
            <h3>Memberships and subscriptions</h3>
            {accountLinks.memberShip.map((card, index) => {
              return (
                <div key={index} className="dashboard-card">
                  <Link to="/" className="card-link">
                    {card}
                  </Link>
                </div>
              );
            })}
          </div>
          <div className="dashboard-link-cards">
            <h3>Shopping programs and rentals</h3>
            {accountLinks.shopping.map((card, index) => {
              return (
                <div key={index} className="dashboard-card">
                  <Link to="/" className="card-link">
                    {card}
                  </Link>
                </div>
              );
            })}
          </div>
          <div className="dashboard-link-cards">
            <h3>Communication and content</h3>
            {accountLinks.communication.map((card, index) => {
              return (
                <div key={index} className="dashboard-card">
                  <Link to="/" className="card-link">
                    {card}
                  </Link>
                </div>
              );
            })}
          </div>
          <div className="dashboard-link-cards">
            <h3>Other Programs</h3>
            {accountLinks.programs.map((card, index) => {
              return (
                <div key={index} className="dashboard-card">
                  <Link to="/" className="card-link">
                    {card}
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
